// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2fJLf","buttons":"SendReceipts_buttons__3a3sn","email":"SendReceipts_email__GobGj","bookApptTitle":"SendReceipts_bookApptTitle__18Kfs"};